import { render } from "./ModalPrecioDinamico.vue?vue&type=template&id=8f2d91c8&scoped=true"
import script from "./ModalPrecioDinamico.vue?vue&type=script&lang=js"
export * from "./ModalPrecioDinamico.vue?vue&type=script&lang=js"

import "./ModalPrecioDinamico.vue?vue&type=style&index=0&id=8f2d91c8&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f2d91c8"]])

export default __exports__